class BlockUseButtonUrl {
  constructor(options = {}) {
    this.config = {
      modulePrimary: document.querySelectorAll('.js-use-btnprimary-url'),
      moduleLink: document.querySelectorAll('.js-use-btnlink-url'),
      itemClass: 'o-macro__item',
      ...options
    };
  }

  init() {
    const { modulePrimary, moduleLink, itemClass } = this.config;

    const setMultipleAttributesOnElement = (elem, elemAttributes) => {
      Object.keys(elemAttributes).forEach(attribute => {
        elem.setAttribute(attribute, elemAttributes[attribute]);
      });
    };

    const setNewWrappedItem = (item, button) => {
      const buttonExists = item.querySelectorAll(`.btn-${button}`);
      if (buttonExists) {
        buttonExists.forEach(btn => {
          const buttonUrl = btn.getAttribute('href');
          const buttonTarget = btn.getAttribute('target');
          const macro = btn.closest(`.${itemClass}`);

          if (macro) {
            const wrapper = document.createElement('a');
            wrapper.innerHTML = macro.innerHTML;
            if (buttonUrl) {
              wrapper.href = buttonUrl;
            }
            if (buttonTarget) {
              wrapper.target = buttonTarget;
            }

            const attributeNodeArray = [...macro.attributes];
            const attributes = attributeNodeArray.reduce((attrs, attribute) => {
              attrs[attribute.name] = attribute.value;
              return attrs;
            }, {});
            setMultipleAttributesOnElement(wrapper, attributes);
            wrapper.classList.remove(`js-use-btn${button}-url`);

            macro.parentNode.appendChild(wrapper);
            macro.remove();
          }
        });
      }
    };

    const setBlockClickWithUrlOf = (module, button) => {
      setNewWrappedItem(module, button);
    };

    if (modulePrimary) {
      modulePrimary.forEach(module => setBlockClickWithUrlOf(module, 'primary'));
    }

    if (moduleLink) {
      moduleLink.forEach(module => setBlockClickWithUrlOf(module, 'link'));
    }
  }
}

export default BlockUseButtonUrl;
